// Components
import CallToAction from "./CallToAction";
import ActionExplanation from "./ActionExplanation";
// Types and Interfaces
import { Locale } from "../../../helpers/localization";

const Hero: React.FC<{ deviceLanguage: Locale }> = ({ deviceLanguage }) => {
  return (
    <section className="hero padding-left-and-right padding-top-80 padding-bottom-40 display-grid gap-20">
      <CallToAction deviceLanguage={deviceLanguage} />
      <ActionExplanation deviceLanguage={deviceLanguage} />
    </section>
  );
};

export default Hero;
